import script from "./ForoCurso.vue?vue&type=script&setup=true&lang=js"
export * from "./ForoCurso.vue?vue&type=script&setup=true&lang=js"

import "./ForoCurso.vue?vue&type=style&index=0&id=714ec8f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714ec8f8"]])

export default __exports__